// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__GzKhA","selected":"Chip_selected__ihehS"};